import React from "react";
import logo from "../../../logo.svg";

const Logo = () => {
  return (
    <img className="app-logo" alt="Copart" src={logo} />
  );
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/help/Logo/index.js